import '@/installCompositionApi'

import { mountComponentTag } from '@/mounter'

import TermsModule from './TermsModule'

mountComponentTag('terms', TermsModule)
